import { render, staticRenderFns } from "./safetyInventory.vue?vue&type=template&id=00063802&scoped=true"
import script from "./safetyInventory.vue?vue&type=script&lang=js"
export * from "./safetyInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00063802",
  null
  
)

export default component.exports